module.exports = __webpack_public_path__ + "img/maintenance-marineholdings.8c548567.jpg";